import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from "@heroui/react";
import ButtonNew from "components/buttonNew/buttonNew";
import { Check, X } from "@phosphor-icons/react";

interface PublishCalendarModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  availableFrom?: string;
  rentalPrice?: number;
  provisions?: number;
}

export const PublishCalendarModal: React.FC<PublishCalendarModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  availableFrom,
  rentalPrice,
  provisions
}) => {
  const formatCurrency = (amount?: number) => {
    if (!amount) return '€ 0,00';
    return `€ ${amount.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const formatDate = (dateString?: string) => {
    if (!dateString) return 'Niet ingesteld';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('nl-NL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch {
      return 'Ongeldige datum';
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      size="md"
      classNames={{
        backdrop: "bg-black/50",
        base: "border border-neutral-primary/20",
        header: "border-b border-neutral-primary/20",
        footer: "border-t border-neutral-primary/20"
      }}
    >
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          <h3 className="text-xl font-semibold text-neutral-primary">
            Publiceren in afsprakenkalender
          </h3>
          <p className="text-sm text-neutral-primary/70 font-normal">
            Controleer de onderstaande gegevens voordat u de unit publiceert
          </p>
        </ModalHeader>
        
        <ModalBody className="py-6">
          <div className="space-y-4">
            <div className="bg-secondary-moss/10 rounded-lg p-4 space-y-3">
              <div className="flex justify-between items-center">
                <span className="font-medium text-neutral-primary">Datum van beschikbaarheid:</span>
                <span className="text-neutral-primary/80">{formatDate(availableFrom)}</span>
              </div>
              
              <div className="flex justify-between items-center">
                <span className="font-medium text-neutral-primary">Huurprijs per maand:</span>
                <span className="text-neutral-primary/80 font-semibold">{formatCurrency(rentalPrice)}</span>
              </div>
              
              <div className="flex justify-between items-center">
                <span className="font-medium text-neutral-primary">Provisie per maand:</span>
                <span className="text-neutral-primary/80 font-semibold">{formatCurrency(provisions)}</span>
              </div>
            </div>
            
            <div className="text-sm text-neutral-primary/60">
              Door te bevestigen wordt deze unit zichtbaar in de publieke afsprakenkalender voor potentiële huurders.
            </div>
          </div>
        </ModalBody>
        
        <ModalFooter>
          <div className="flex gap-3 w-full">
            <ButtonNew
              label="Annuleren"
              variant="secondaryNeutral"
              icon={<X size={16} />}
              onClick={onClose}
              className="flex-1"
            />
            <ButtonNew
              label="Bevestigen en publiceren"
              variant="primaryMoss"
              icon={<Check size={16} />}
              onClick={onConfirm}
              className="flex-1"
            />
          </div>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
